import React, { createContext, useState, useContext, useEffect } from 'react';
import { getMe } from '../utils/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // sessionStorage token = impersonation session (tab-isolated, doesn't affect admin tab)
    // localStorage token   = normal login session
    const token = sessionStorage.getItem('pwc_token') || localStorage.getItem('pwc_token');
    if (token) {
      getMe()
        .then(res => {
          setUser(res.data.user);
        })
        .catch(() => {
          sessionStorage.removeItem('pwc_token');
          sessionStorage.removeItem('pwc_user');
          localStorage.removeItem('pwc_token');
          localStorage.removeItem('pwc_user');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = (token, userData) => {
    localStorage.setItem('pwc_token', token);
    localStorage.setItem('pwc_user', JSON.stringify(userData));
    setUser(userData);
    getMe()
      .then(function(res) { setUser(res.data.user); })
      .catch(function() { /* keep userData from login response */ });
  };

  const logout = () => {
    // Clear both storage types (handles impersonation sessions too)
    sessionStorage.removeItem('pwc_token');
    sessionStorage.removeItem('pwc_user');
    localStorage.removeItem('pwc_token');
    localStorage.removeItem('pwc_user');
    setUser(null);
    window.location.href = 'https://pranicwellnesscentre.com/?pwc_logout=1';
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export default AuthContext;
